// extracted by mini-css-extract-plugin
export default {"icons":"Bar_icons__vSbFP","iconContainer":"Bar_iconContainer__zukSq","iconText":"Bar_iconText__fatqb","formIcon":"Bar_formIcon__jxqur"};